/* eslint-disable no-irregular-whitespace */
import React from 'react'
import { Marker, OverlayView } from '@react-google-maps/api'
import { EnrollmentLocation } from '@utils/getNearbyEnrollmentLocations'
import { useFlag } from '@hooks/useFlag'

interface PinMarkerProps {
  location: EnrollmentLocation
  onClick?: () => void
  markerNumber: string
  isSelectedLocation: boolean
}

const V1Marker = ({
  location,
  onClick,
}: {
  location: EnrollmentLocation
  onClick: () => void
}) => {
  return (
    <Marker
      data-testid="v1-marker"
      key={location.locationCode}
      position={location.location}
      onClick={onClick}
    />
  )
}

const V2Marker = ({
  location,
  isSelectedLocation,
  markerNumber,
  onClick,
}: {
  location: EnrollmentLocation
  markerNumber: string
  isSelectedLocation: boolean
  onClick: () => void
}) => {
  return (
    <>
      <Marker
        data-testid="v2-marker"
        key={location.locationCode}
        position={location.location}
        label={{
          text: markerNumber,
          color: 'black',
          fontSize: '16px',
          fontWeight: 'bold',
        }}
        icon={{
          path: 'M 0,-30 C -10,-30 -18,-22 -18,-12 C -18,0 0,15 0,15 C 0,15 18,0 18,-12 C 18,-22 10,-30 0,-30 Z',
          fillColor: 'white',
          fillOpacity: 0.75,
          strokeColor: '#1E3A8A',
          strokeWeight: isSelectedLocation ? 5 : 4,
          scale: isSelectedLocation ? 1 : 0.75,
          labelOrigin: new google.maps.Point(0, -10),
        }}
        onClick={onClick}
      />
      {isSelectedLocation && (
        <OverlayView
          position={{
            lat: location.location.lat,
            lng: location.location.lng,
          }}
          mapPaneName={OverlayView.OVERLAY_MOUSE_TARGET}
        >
          <div
            style={{
              position: 'absolute',
              transform: 'translate(-50%, 20px)',
            }}
          >
            <div className="bg-white px-6 py-3 rounded-lg shadow-lg">
              <p className="text-md font-normal text-gray-900 whitespace-nowrap">
                {location.name}
              </p>
            </div>
          </div>
        </OverlayView>
      )}
    </>
  )
}

export function PinMarker({
  location,
  onClick,
  markerNumber,
  isSelectedLocation,
}: PinMarkerProps) {
  const displayLocationSearchRevisedLayout =
    useFlag('layoutRefresh')?.displayLocationSearchRevisedLayout
  return !displayLocationSearchRevisedLayout ? (
    <V1Marker location={location} onClick={onClick} />
  ) : (
    <V2Marker
      location={location}
      onClick={onClick}
      isSelectedLocation={isSelectedLocation}
      markerNumber={markerNumber}
    />
  )
}
